import {Box, Stack, Typography} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleCheck} from '@fortawesome/pro-light-svg-icons';

/**
 * Component representing a checked confirmation message.
 *
 * @component
 * @returns {JSX.Element} The CheckedConfirmation component.
 */
export const CheckedConfirmation = () => {
  return (
    <Stack alignItems="center" mb={{sm: 0, md: 0, lg: 14}}>
      <Typography variant="h4" sx={{fontSize: {xs: '22px', sm: '36px'}, my: 1}} textAlign="center">
        All done!
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          marginTop: 1,
          maxWidth: '650px',
          fontSize: {xs: '15px', sm: '20px'},
        }}
        textAlign="center"
      >
        Press 'next' to continue.
      </Typography>
      <Box
        fullWidth
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: {xs: 30, sm: 11},
          mb: 1,
        }}
      >
        <FontAwesomeIcon
          icon={faCircleCheck}
          size={'6x'}
          style={{
            color: 'rgba(80, 186, 71, 0.24)',
          }}
        />
      </Box>
    </Stack>
  );
};
